import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { taxSettingUpdate } from '../../../redux/actions/taxSettings';

const EditTaxSettingModal = ({ payload, showEditTaxSettingModal, setShowEditTaxSettingModal, taxSetting, editTaxSetting }) => {
  const [taxName, setTaxName] = useState(null);
  const [taxRate, setTaxRate] = useState(null);
  const [code, setCode] = useState(null);

  const taxSettingJson = () => {
    return {
      rate: (taxRate || taxSetting.rate),
      code: (code || taxSetting.code),
      tax_name: (taxName || taxSetting.tax_name),
      type: 'purchase',
    }
  }

  const changeRate = (event) => {
    let value = event.target.value;
    setTaxRate(value);
  }

  const changeName = (event) => {
    let value = event.target.value;
    setTaxName(value);
  }

  const changeCode = (event) => {
    let value = event.target.value;
    setCode(value);
  }

  const update = () => {
    editTaxSetting(payload, taxSetting.id, taxSettingJson());
    setShowEditTaxSettingModal(false);
  }

  return(
    <>
      { taxSetting &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowEditTaxSettingModal(false),
            },
            { text: 'Update Tax Setting', onClick: () => update() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Update Tax Setting"
          isOpen={showEditTaxSettingModal}
          onClose={() => setShowEditTaxSettingModal(false)}
        >
          <H3>Update {taxSetting.tax_name}</H3>
          <Input
            description={`Current value: ${taxSetting.tax_name}`}
            label="Tax Name"
            onChange={changeName}
            placeholder="Tax Name"
            type="text"
            value={taxName}
            required
          />

          <Input
            description={`Current value: ${taxSetting.rate}`}
            label="Tax Rate (%)"
            onChange={changeRate}
            placeholder="Tax Rate (%)"
            type="number"
            min="0"
            value={taxRate}
            required
          />

          <Input
            description={`Current value: ${taxSetting.code}`}
            label="Code"
            onChange={changeCode}
            placeholder="Code"
            type="text"
            value={code}
            required
          />
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  editTaxSetting: (payload, taxSettingId, taxSetting) => dispatch(taxSettingUpdate(payload, taxSettingId, taxSetting)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditTaxSettingModal);